import * as React from 'react';
import { Messages } from '../../../../gen-src/Localize';
import { divWithStyle } from '../../style/LayoutComponents';
import { cssClass } from '../../style/StyleFunctions';
import { TypedBodyCellProps } from '../TypedDataGridInterfaces';
import { cellPaddingStyle } from './CellStyles';

/**
 * This inlines a display: flex; onto the certified icons because the chrome tooltip widget used to
 * create the certification tooltip wraps the svg in its own div with its own styles which ruins the
 * vertical alignment of only the certified icons.
 * The nest selector is for IE11 and will need to exist until ChromeTooltipWidget is refactored away.
 */
export const certifiedListIconStyle = cssClass('IconCell', {
  ...cellPaddingStyle,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  $nest: {
    '& > div': {
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important'
    }
  }
});

const DisabledIconContainer = divWithStyle('DisabledIconCell', {
  ...cellPaddingStyle,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  opacity: 0.6,
});

interface IconCellFormatterProps {
  readonly disabled?: boolean;
  readonly icon: JSX.Element;
  readonly title: string;
}

function IconCellFormatter(props: IconCellFormatterProps) {
  return props.disabled ?
    <DisabledIconContainer title={props.title}>{props.icon}</DisabledIconContainer>
    :
    <div className={certifiedListIconStyle} title={props.title}>{props.icon}</div>;
}

export function createIconCellFormatter<T>(
  getIconFromRowData: (rowData: T) => JSX.Element,
  getTitleFromRowData: (rowData: T) => string,
  getDisabledFromRowData?: (rowData: T) => boolean
): React.Factory<TypedBodyCellProps<T>> {
  // eslint-disable-next-line react/display-name
  return (props: TypedBodyCellProps<T>) => (
    <IconCellFormatter
      disabled={getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false}
      icon={getIconFromRowData(props.row.data)}
      title={getTitleFromRowData(props.row.data)}
    />
  );
}

export function getDSHoverTitleString(isCertified: boolean, hasExtracts: boolean): string {
  if (isCertified) {
    return '';
  } else {
    return hasExtracts ? Messages.DataDetailsDatasourceExtract() : Messages.DataDetailsDatasourceLive();
  }
}
